export const SET_WORKSPACES = 'Set workspaces'
export const DELETE_WORKSPACE = 'Delete workspaces'
export const UPDATE_WORKSPACE = 'Update workspaces'
export const SET_WORKSPACES_COUNT = 'Set workspaces count'
